<template>
	<div class="iosManual">
		<div class="top">iOS下载安装异常说明</div>
		<Scrapper class="view">
			<div class="tie">
				<p>
					1.提示无法连接AppStore Connect;
					<span class="open" @click="changeStep(0)">查看详情></span>
				</p>

				<p>
					2.当下载时出现下图提示，请在30分钟后重试；
				</p>
			</div>
			<div class="image">
				<img src="./images/iosd1.png" />
				<img src="./images/iosd2.png" />
				<img src="./images/iosd3.png" />
				<img src="./images/iosd4.png" />
			</div>
			<div class="tie">
				<p>
					3.用户下载TF包有效期在三个月，如果失效请重新下载，VIP用户绑定手机号即可找回VIP账号;
				</p>
				<p>
					4.如上述情况都不是或领取永久域名，请通过以下方式联系我们:
				</p>
			</div>
			<ul class="message">
				<!-- <li>
                <p @click="open">点击留言 ></p>
            </li> -->
				<li>
					<img src="./images/mailbox.png" /><a href="mailto:kehufuwu888@gmail.com">kehufuwu888@gmail.com</a>
				</li>
			</ul>
			<p class="prompt">提示：通过邮箱反馈需包含APP名称以及异常情况说明及图片。</p>
		</Scrapper>
		<div class="dns_roller" v-show="dnstep>=0" @touchstart.prevent>
			<div class="gap left" @touchstart="changeStep(dnstep>0?dnstep-1:0)">
				<img v-show="dnstep>1" class="img" src="./images/prev.png" />
			</div>
			<div class="dns_post">
				<div v-show="dnstep==0" class="dns_alert">
					<div class="tip">{{TFInfo.appName}}提示</div>
					<p class="text">
						如出现<span>TestFlight</span>无法接入AppStore Connect,或者无法打开AppStore的情况；
						请先修改DNS配置为公共DNS的ip，如：114.114.114.114（国内）8.8.4.4（国外）,或者使用VPN连接国外节点下载！
					</p>
					<div class="down">
						<div class="back" @touchstart="changeStep(-1)">返回</div>
						<div class="open" @touchstart="changeStep(1)">查看教程</div>
					</div>
				</div>
				<img class="img" v-show="dnstep==1" src="./images/dns_step1.png" />
				<img class="img" v-show="dnstep==2" src="./images/dns_step2.png" />
				<img class="img" v-show="dnstep==3" src="./images/dns_step3.png" />
				<img class="img" v-show="dnstep==4" src="./images/dns_step4.png" />
			</div>
			<div v-show="dnstep>0" class="close" @touchstart="changeStep(-1)">
				<img class="img" src="./images/close.png" />
			</div>
			<div class="gap right" @touchstart="changeStep(dnstep<4?dnstep+1:4)">
				<img v-show="dnstep<4&&dnstep>0" class="img" src="./images/next.png" />
			</div>
		</div>
	</div>
</template>
<script>
import Scrapper from '@/libaray/component/Scrapper'
export default {
	components: { Scrapper },
	data: function () {
		return {
			dnstep: -1
		}
	},
	computed: {
		TFInfo() {
			return {
				expImg: null,
				appName: '',
				class: '',
				...this.viewInfo
			}
		}
	},
	methods: {
		open() {
			this.$parent.open()
		},
		changeStep(param) {
			this.dnstep = param;
		}
	}
}
</script>
<style lang="scss" >
.iosManual {
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	position: relative;
	background: #fff;
	.view {
		flex: 1 1 0;
		overflow: hidden;
		background: #fff !important;
	}
	.top {
		height: 49px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 15px;
		color: #272a2d;
		line-height: 1;
		box-shadow: 0 2px 4px 0 rgba(232, 232, 232, 0.5);
	}
	.tie {
		display: flex;
		justify-content: left;
		align-items: center;
		flex-wrap: wrap;
		margin-top: 15px;
		p {
			padding-left: 25px;
			font-size: 15px;
			color: #888f9a;
			padding-top: 20px;
			display: flex;
		}
	}
	.image {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		margin: 0 auto;
		img {
			display: block;
			width: 150px;
			margin: 0 10px;
			height: auto;
			border: 1px solid rgb(141, 141, 141);
			border-radius: 12px;
			margin-top: 25px;
		}
	}
	.message {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		margin-top: 10px;
		li {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			padding-left: 25px;
			margin-bottom: 15px;
			i {
				width: 25px;
				height: 25px;
				border-radius: 50%;
				display: block;
				background: #f14ea6;
				font-style: normal;
				color: #fff;
				text-align: center;
			}
			img {
				width: 20px;
				height: 16px;
				display: block;
				margin-top: 5px;
				margin-left: 15px;
			}
			a {
				margin-left: 15px;
				font-size: 15px;
				color: #544ef1;
				letter-spacing: 0.77px;
				border-bottom: 1px solid #544ef1;
			}
		}
		li:first-of-type {
			p {
				height: 30px;
				width: 100px;
				border: 1px solid #f14ea6;
				margin-left: 15px;
				color: #f14ea6;
				text-align: center;
				border-radius: 8px;
				line-height: 30px;
			}
		}
	}
	.prompt {
		font-size: 14px;
		color: #a9a9a9;
		display: block;
		width: 85%;
		margin: 0 auto;
		padding-bottom: 20px;
	}
	.open {
		flex: 1 1 0;
		// height: 54px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #ff2525;
		color: #ff2525;
		padding: 5px;
		margin-left: 10px;
	}
}
.dns_roller {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 99;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	.gap {
		width: 15%;
		flex: 0 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		.img {
			display: block;
			width: 70%;
			//margin: 0 auto;
		}
	}
	& > .close {
		position: absolute;
		bottom: 0;
		left: 50%;
		height: 10%;
		transform: translateX(-50%);
		.img {
			height: 80%;
			display: block;
			margin: 0 auto;
		}
	}
	.dns_post {
		flex: 1 1 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 80%;
		position: relative;
		.img {
			display: block;
			max-width: 100%;
			max-height: 100%;
		}
	}
	.dns_alert {
		background: #fff;
		border-radius: 10px;
		overflow: hidden;
		.tip {
			text-align: center;
			font-size: 18px;
			padding: 14px 0 14px 0;
		}
		.text {
			padding: 0 20px 20px 20px;
			font-size: 15px;
			color: #747474;
			line-height: 1.2;
			word-break: break-all;
			span {
				color: #eb5228;
			}
		}
		.down {
			display: flex;
			height: 54px;
			.back,
			.open {
				flex: 1 1 0;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.back {
				background: #e8e8e8;
				color: #272a2d;
			}
			.open {
				background: #eb5228;
				color: #ffffff;
				padding: 0;
				margin: 0;
			}
		}
	}
}
</style>